var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("Redirecionando...")]),_c('div',{staticClass:"hello"},[_vm._v(" "+_vm._s(_vm.msg)+" "+_vm._s(_vm.android)+" "+_vm._s(_vm.ios)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }